import React from 'react';
import {
    Cell,
    Label,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip
} from 'recharts';
import theme from '../../../theme';

const COLORS = ['#C4B5FD', '#EDE9FE', '#C4B5FD', '#EDE9FE'];

interface HalfPieChartProps {
    labels: [string, string];
    rate: number;
    width?: number | string;
    height?: number | string;
}

const HalfPieChart: React.FC<HalfPieChartProps> = ({ labels, rate, width = "100%", height = 400 }) => {

    const data = [
        { name: labels[0], value: rate },
        { name: labels[1], value: 100 - rate }
    ];

    const CustomTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            const value = payload[0].value;
            return (
                <div style={{ backgroundColor: '#fff', padding: theme.spacing(1), border: '1px solid #ccc' }}>
                    {`${value}%`}
                </div>
            );
        }
        return null;
    };

    return (
        <ResponsiveContainer width={width} height={height}>
            <PieChart>
                <Pie
                    data={data}
                    cx="50%"
                    cy="100%"
                    startAngle={180}
                    endAngle={0}
                    innerRadius={height === "100%" ? 60 : Number(height) / 2}
                    outerRadius={height === "100%" ? 80 : Number(height) / 2 + 20}
                    fill="#8884d8"
                    dataKey="value"
                >
                    <Label
                        value={`${rate}%`}
                        position="center"
                        fill="#000000"
                        dy={-10}
                        style={{
                            fontSize: theme.typography['report.info.label'].fontSize,
                            fontWeight: 'bold',
                        }}
                    />
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
            </PieChart>
        </ResponsiveContainer>

    );
};

export default HalfPieChart;
